const Row = ({ children, hour }) => {
    return (
        <div className="calendar-weekly-table__hour">
            <div className="calendar-weekly-table__main-time">
                <span>{hour.toString().padStart(2, "0")}:00</span>
            </div>
            {children}
        </div>
    );
};

export default Row;